export default __webpack_public_path__ + "static/media/repulse.40034bd2.png";